var _effectorFileName = "/src/shared/lib/seo/locale-urls.ts";
import { DEFAULT_LOCALE } from '@/shared/config/i18n';
export const stripQuery = (asPath: string): string => {
  const q = asPath.indexOf('?');
  return q === -1 ? asPath : asPath.slice(0, q);
};

/** Locale-stripped path → path as served on enlerno.com for the given locale. */
export const getComLocalePath = (pathWithoutQuery: string, locale: string): string => {
  const path = pathWithoutQuery || '/';
  if (locale === DEFAULT_LOCALE || locale === 'en') {
    return path;
  }
  if (path === '/') {
    return `/${locale}`;
  }
  return `/${locale}${path}`;
};
const joinBaseAndPath = (baseUrl: string, path: string): string => {
  const base = baseUrl.replace(/\/$/, '');
  if (path === '/') {
    return `${base}/`;
  }
  return `${base}${path}`;
};
export const getCanonicalUrl = (args: {
  appUrl: string;
  asPath: string;
  locale: string;
}): string => {
  const path = stripQuery(args.asPath);
  const localePath = getComLocalePath(path, args.locale);
  return joinBaseAndPath(args.appUrl, localePath);
};
export const getLanguageAlternates = (args: {
  appUrl: string;
  ruSiteUrl: string;
  asPath: string;
}): Array<{
  hrefLang: string;
  href: string;
}> => {
  const path = stripQuery(args.asPath);
  const enPath = getComLocalePath(path, 'en');
  const ruPath = getComLocalePath(path, 'ru');
  return [{
    hrefLang: 'en',
    href: joinBaseAndPath(args.appUrl, enPath)
  }, {
    hrefLang: 'ru',
    href: joinBaseAndPath(args.appUrl, ruPath)
  }, {
    hrefLang: 'ru-RU',
    href: joinBaseAndPath(args.ruSiteUrl, enPath)
  }, {
    hrefLang: 'x-default',
    href: joinBaseAndPath(args.appUrl, enPath)
  }];
};
export const getOpenGraphLocale = (locale: string): 'en_US' | 'ru_RU' => {
  return locale === 'ru' ? 'ru_RU' : 'en_US';
};